import { SvgIcon } from '@mui/material';

const PrinterlessDropOff = props => (
  <SvgIcon width='25' height='25' viewBox='0 0 25 25' {...props}>
    <g id='Group_142' data-name='Group 142' transform='translate(-7354 -6286)'>
      <circle
        id='Ellipse_3'
        data-name='Ellipse 3'
        cx='12.5'
        cy='12.5'
        r='12.5'
        transform='translate(7354 6286)'
        fill='#fff'
      />
      <g
        id='Group_19'
        data-name='Group 19'
        transform='translate(7360.078 6292.17)'
      >
        <g id='Group_19-2' data-name='Group 19'>
          <path
            id='Path_2'
            data-name='Path 2'
            d='M89.678,121.4a.429.429,0,0,1,.429.429v2.36a.429.429,0,0,1-.429.429H84.1a.429.429,0,0,1-.429-.429v-.3l-.77.77a1.287,1.287,0,0,0,1.2.82h5.579a1.287,1.287,0,0,0,1.287-1.287v-1.5h1.073a1.287,1.287,0,0,0,1.287-1.287v-3.862a1.287,1.287,0,0,0-1.287-1.287h-.732L86.157,121.4Zm1.5-3.862a.858.858,0,1,1-.858.858.858.858,0,0,1,.858-.858'
            transform='translate(-80.452 -112.814)'
            fill='#dc0032'
          />
          <path
            id='Path_3'
            data-name='Path 3'
            d='M3.218,3.432V1.286A.429.429,0,0,1,3.648.857H9.011a.429.429,0,0,1,.429.429V1.63l.782-.782A1.288,1.288,0,0,0,9.011,0H3.648A1.287,1.287,0,0,0,2.36,1.286V3.432H1.287A1.287,1.287,0,0,0,0,4.719V8.581A1.287,1.287,0,0,0,1.2,9.866L7.639,3.432Z'
            transform='translate(0 0.001)'
            fill='#dc0032'
          />
          <path
            id='Path_4'
            data-name='Path 4'
            d='M13.387,1.331q-.009-.022-.02-.043a.487.487,0,0,0-.776-.118L.939,12.821a.5.5,0,0,0-.033.037.483.483,0,0,0-.054.081q-.011.021-.02.043a.484.484,0,0,0-.027.09.489.489,0,0,0,.011.232.487.487,0,0,0,.812.206L13.28,1.859a.485.485,0,0,0,.141-.3q0-.023,0-.047a.488.488,0,0,0-.036-.183'
            transform='translate(-0.773 -0.997)'
            fill='#dc0032'
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export default PrinterlessDropOff;
